import { render, staticRenderFns } from "./NotenTransactionList.vue?vue&type=template&id=26d3e05a&"
import script from "./NotenTransactionList.vue?vue&type=script&lang=js&"
export * from "./NotenTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports